<template>
  <va-modal
    :value="isOpen"
    ref="bulkUploadModal"
    :okText="'reports.templates.buttons.confirm' | translate"
    :okClass="'btn btn-primary btn-micro btn-disabled'"
    :okToClose="false"
    :okDisabled="form.data.uploads.length === 0"
    @ok="submit"
    :cancelText="'reports.templates.buttons.cancel' | translate"
    :cancelClass="'btn-cancelar btn btn-primary btn-micro'"
    @cancel="close"
    :medium="true"
  >

    <div slot="title"><b style="font-size:22px;">{{ $t('reports.reports.titles.bulk_update') }}</b></div>

    <input id="excels-input" type="file" @change="onFilesSelected" hidden accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" multiple>
    <div class="d-flex w-100 justify-content-between">
      <h5>
        <b>{{$t('reports.reports.labels.selected_files')}}
        <span v-if="form.data.uploads.length > 0"> ({{form.data.uploads.length}})</span>
        </b>
      </h5>
      <div>
        <va-popover
          v-if="form.data.uploads.length > 0"
          placement="left"
          :message="$t('reports.reports.buttons.delete_all_uploads')">
          <i class="report-action-icon fa fa-trash pl-2 pr-2 clickable" @click.prevent.stop="resetUploads()"></i>
        </va-popover>

        <va-popover
          placement="left"
          :message="$t('reports.reports.buttons.upload_reports')">
          <i class="report-action-icon fa fa-upload pl-2 pr-2 clickable" @click.prevent.stop="uploadFiles()"></i>
        </va-popover>

      </div>
    </div>
    <div class="row mb-4 mt-3">
      <div v-if="form.data.uploads.length === 0" class="col-12 text-center">
        <span><b>{{$t('reports.reports.labels.no_selected_files')}}</b></span>
      </div>

      <div v-else v-for="(upload, index) in form.data.uploads" :key="index" class="col-12 row">
        <div class="d-flex justify-content-between col-12">
          <span class="filename">{{upload.name}}</span>
          <span>{{presentSize(upload.size)}}</span>
          <va-popover
            v-if="!upload.sent || upload.errors"
            placement="left"
            :message="$t('reports.reports.buttons.delete_upload')">
            <i class="report-action-icon fa fa-times pl-2 pr-2 clickable" @click.prevent.stop="removeUpload(index)"></i>
          </va-popover>

          <va-popover
            v-else
            placement="left"
            :message="$t('reports.reports.labels.upload_successful')">
            <i class="report-action-icon fa fa-check pl-2 pr-2"></i>
          </va-popover>
        </div>

        <small v-show="form.errors.has(`uploads.${index}`)" class="help text-danger col-12 mb-3">
          {{ form.errors.get(`uploads.${index}`) | translate }}
        </small>
      </div>
    </div>
    <div v-if="successfulUploads.length > 0">
      <hr>
      <div class="d-flex w-100 justify-content-between">
        <h5>
          <b>{{$t('reports.reports.labels.successful_uploads')}}</b>
         <span>({{successfulUploads.length}})</span>
        </h5>
        <div>
          <va-popover
            placement="left"
            :message="$t('reports.reports.buttons.close_section')">
            <i class="report-action-icon fa fa-times-circle pl-2 pr-2" @click.prevent.stop="closeSuccessfulUploads()"></i>
          </va-popover>
        </div>
      </div>
    </div>
    <div v-if="successfulUploads.length > 0" class="row mt-3">
      <div v-for="(upload, index) in successfulUploads" :key="index" class="col-12 d-flex justify-content-between">
        <span class="filename">{{upload.name}}</span>
        <span>{{presentSize(upload.size)}}</span>
        <div class="p-2"></div>
      </div>
    </div>
  </va-modal>
</template>
<script>
import Errors from '@/utils/StandardErrors'
const transitionDuration = 500

export default {
  props: {
    serviceUrl: {
      type: String,
      required: true
    }
  },
  data: function () {
    return {
      isOpen: false,
      isWaitingForResponse: false,
      form: {
        url: `${this.serviceUrl}/reports/bulk-upload-excel`,
        method: 'POST',
        data: {
          uploads: []
        },
        errors: new Errors()
      },
      successfulUploads: []
    }
  },
  mounted: function () {
    this.isOpen = true
  },
  methods: {
    submit: function () {
      this.form.errors.clear()
      let formData = new FormData()

      this.form.data.uploads.forEach((element, index) => {
        formData.append(`uploads[${index}]`, element)
      })
      this.$http({
        url: this.form.url,
        method: this.form.method,
        data: formData
      })
      .then(response => {
        this.showToast(this.$t('reports.reports.messages.bulk_upload_excel_success', {successful_count: response.data.successful_count}), this.$store.state.successToastOptions)
        this.isOpen = false
        this.$emit('bulkUpload', response,data.data)
      })
      .catch(errors => {
        let message = null
        if (errors.response.status === 422) {
          let responseData = errors.response.data
          this.form.errors.record(responseData.errors, 'reports.reports.errors.')
          let unsuccessfulIndexes = Object.keys(responseData.errors).map(element => {
            return parseInt(element.substring(8))
          })

          let unsuccesfulUploads = []
          this.form.data.uploads.forEach((element, index) => {
            if (unsuccessfulIndexes.includes(index)) {
              unsuccesfulUploads.push(element)
            } else {
              this.successfulUploads.push(element)
            }
          })

          this.form.data.uploads = unsuccesfulUploads

          // clear excels that were successful
          message = this.$t('reports.reports.messages.unsuccessful_bulk_upload_excel')
                        .replace('$placeholder1', responseData.successful_count)
                        .replace('$placeholder2', responseData.original_count)
        } else {
          message = this.$t('reports.reports.messages.something_went_wrong')
        }

        this.showToast(message, this.$store.state.errorToastOptions)
      })
    },
    close: function () {
      setTimeout(() => {
        this.$emit('modalWasClosed')
      }, transitionDuration)
    },
    uploadFiles: function () {
      document.getElementById('excels-input').click()
      this.form.errors.clear()
    },
    onFilesSelected: function (event) {
      if (event.target.files.length > 0) {
        for (let i = 0; i < event.target.files.length; i++) {
          this.form.data.uploads.push(event.target.files[i])
        }
      }
    },
    resetUploads: function () {
      this.form.data.uploads = []
      document.getElementById('excels-input').value = ''
    },
    removeUpload: function (index) {
      this.form.data.uploads.splice(index, 1)
    },
    presentSize: function (bytes) {
      var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
      if (bytes === 0) return '0 Byte'
      var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)))
      return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i]
    },
    closeSuccessfulUploads: function () {
      this.successfulUploads = []
    }
  }
}
</script>
<style scoped lang="scss">
.filename {
  width: 60%;
}
</style>

